var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineLgRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineLgRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 200,
    viewBox: "0 0 500 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.1,157.1h0v-11.8c-.1-.5-.1-1,0-1.5v-7.3c-1.5.3-2.8,1.2-3.7,2.6-1.1,1.7-1.2,3.8-.2,5.6l2.5,4.9c.2.5.4,1,.4,1.5,0,1.9-.7,3.6-2,5l-1.7,1.8c-.6.7-1.1,1.4-1.5,2.2h2.8c1.9,0,3.5-1.3,3.5-3Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,36.3c.4,0,.7.2,1.1.2,1.4,0,2.7-.9,3.2-2.3l6.6-20c.6-1.8-.4-3.7-2.1-4.2-1.8-.6-3.7.4-4.2,2.1l-6.6,20c-.6,1.8.4,3.7,2.1,4.2Z",
    style: {
      fill: "#55c3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4,49.1c.6.4,1.3.7,2,.7,1,0,2-.5,2.7-1.3l10-13.3c1.1-1.5.8-3.6-.7-4.6-1.5-1.1-3.6-.8-4.6.7l-10,13.3c-1.1,1.5-.8,3.6.7,4.6Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.2,164.6c0-4.8-1.4-7.2-3.9-9.8l-1.7-1.8c-.3-.3-.7-.8-.7-1.5l2.3-4.6c1.6-3.3,1.5-7-.4-10.1-2-3.1-5.4-4.9-9-4.9s-4.7.5-6.9,1.4l-2.1.8c-.3.1-.4.2-.6.3,0,0,0,0,0,0h-.1c0,0,0-.1,0-.1h0s0,0,0,0h0s-2.2-1-2.2-1c-.5-.2-1-.4-1.4-.5-1.8-.6-3.7-.9-5.6-.9s-1,0-1.5.1c-3,.4-5.7,2.1-7.4,4.7-2,3.1-2.2,6.9-.5,10.2l2.4,4.6c0,.7-.5,1.2-.8,1.6l-1.7,1.8c-1.3,1.4-2.4,3.1-3,5-.6,1.6-.8,3.2-.8,4.8v.2c0,.7,0,1.4.2,2.1.3,2,1.1,3.9,2.3,5.5-1.6,2.1-2.5,4.6-2.5,7.2v1.1c0,7.7,7.7,14,14.1,14h.2c4.5,0,7.4-1.4,8.6-2.2,1.2.8,4.1,2.2,8.8,2.2,6.4,0,14.1-6.2,14.1-14v-1c0-2.6-.8-5.1-2.3-7.1,1.1-1.3,2.6-3.7,2.6-7.9ZM140.1,170.1c-.1,0-.3,0-.4,0-2,0-7.4-.8-7.4-4.3,0-1,.4-2.3,1.2-2.8.4-.3,1-.4,1.5-.4s.9.1,1.3.3c.4.2.7.3,1.1.3.8,0,1.6-.5,2-1.2.3-.5.3-1.1.2-1.7-.2-.6-.6-1.1-1.1-1.3-1.1-.6-2.3-.9-3.5-.9s-2.5.3-3.7,1c-2.2,1.3-3.5,3.6-3.6,6.2,0,2.5.7,4.6,2.3,6.2,2.9,3,7.6,3.3,9.6,3.3,0,0,.2.2.3.2,1.5,1.2,2.4,2.9,2.4,4.9v1c0,4.6-3.8,8.3-8.4,8.3h-.3c-1,0-1.9-.1-2.9-.4-.8-1-1.3-2.3-1.3-3.6h0c0-2.9,0-3.8,1.9-4.4h0s0,0,0,0c1.2-.5,1.8-1.8,1.3-3-.3-.9-1.2-1.5-2.2-1.5s-.5,0-.8.1c-3.2,1.2-4.3,3.3-4.7,5.7-.4-2.4-1.6-4.5-4.7-5.7-.2,0-.5-.1-.8-.1-.9,0-1.8.6-2.2,1.5-.4,1.1.2,2.5,1.3,3h0s0,0,0,0c1.8.7,1.9,1.5,1.9,4.4h0c0,1.4-.5,2.7-1.3,3.7-.9.2-1.8.3-2.7.3h-.3c-4.6,0-8.4-3.7-8.4-8.3v-1.1c0-1.9.8-3.6,2.3-4.8,0,0,.1-.1.2-.2.2,0,.3,0,.4,0,1.9,0,6.8-.3,9.7-3.3,1.6-1.6,2.3-3.7,2.3-6.2,0-1.9-.8-3.6-2-5-.5-.5-1-.9-1.5-1.2-1.2-.6-2.4-1-3.7-1s-2.4.3-3.5.9c-.5.3-.9.7-1.1,1.3-.2.6-.1,1.2.1,1.8.4.7,1.1,1.2,2,1.2s.7,0,1.1-.3c.4-.2.9-.3,1.3-.3.5,0,1.1.2,1.5.4.2.1.4.4.6.7.3.6.5,1.4.5,2.1,0,3.5-5.3,4.3-7.4,4.3s-.4,0-.7,0c-1-1-1.7-2.3-2-3.6-.1-.6-.2-1.1-.2-1.6v-.2c0-1.4.3-2.8,1-4,.4-.7.8-1.4,1.4-1.9l1.7-1.8c1.5-1.6,2.3-3.6,2.3-5.7s-.2-1.4-.5-2l-2.5-4.9c-.8-1.5-.7-3.2.2-4.6.7-1.1,1.8-1.8,3-2.1.4,0,.8-.1,1.1-.1,1.7,0,3.3.3,4.8,1h.1c0,0,2.1,1,2.1,1h.1c.7.4,1.4.8,2.6.8s1.7-.3,2.3-.6c.1,0,.3-.1.4-.2l2.2-.8h0s0,0,0,0c1.5-.7,3.1-1,4.8-1s3.2.8,4.1,2.2c.8,1.4.9,3.1.2,4.6l-2.5,4.9c-.3.6-.5,1.3-.5,2,0,2.1.8,4.1,2.3,5.7l1.7,1.8c1.4,1.5,2.2,3.4,2.3,5.5v.5s0,.2,0,.2c0,2-.8,3.9-2.4,5.2Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,150.8c-.2,0-.3,0-.5,0-.7.3-1.4.5-2.1.6v-2.8c.9-.2,1.5-.7,1.5-1.2,0-.8-1.2-1.4-2.7-1.4s-2.7.6-2.7,1.4.7,1,1.6,1.3v2.7c-.6-.1-1.3-.3-1.9-.6-.2,0-.3-.1-.5-.1-.3,0-.5,0-.7.3-.2.1-.3.3-.4.5-.3.5,0,1.2.4,1.5,0,0,.1,0,.2.1,1.4.6,2.8,1,4.2,1s2.8-.3,4.2-1c.7-.2.9-1,.7-1.6-.2-.4-.7-.7-1.1-.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3,141.2c-.9,0-1.8.4-2.4,1-.5.5-.5,1.2,0,1.7.2.2.6.4.9.4s.6-.1.9-.4c.2-.2.4-.3.7-.3s.5,0,.6.3c.2.2.2.4.2.7s-.1.5-.2.7c-.5.5-.5,1.2,0,1.7.2.2.6.4.9.4s.6-.1.9-.4h0c.6-.6,1-1.5,1-2.4s-.4-1.7-1-2.4c-.6-.6-1.5-1-2.4-1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,143.9c.5-.5.5-1.2,0-1.7-.6-.7-1.5-1-2.4-1-.8,0-1.7.3-2.3,1-.5.5-.7,1-.9,1.6v1.5c.1.6.4,1.2.9,1.6.2.2.6.4.9.4s.6-.1.9-.4c.5-.5.5-1.2,0-1.7-.4-.4-.4-1,0-1.3.2-.2.4-.3.7-.3s.5,0,.6.3c.2.2.5.4.9.4s.6-.1.9-.4h0Z",
    style: {
      fill: "#b40055"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.8,
    y: 51.6,
    width: 34.8,
    height: 6.9,
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6,51.6c-4.5,0-8.2,3.7-8.2,8.2v97.5c0,5.3,4.3,9.6,9.7,9.6h72.8v-6.9H25.6c-1.7,0-3.1-1.4-3.1-3.1V61.6c0-1.7,1.4-3.1,3.1-3.1h13.2v-6.9h-15.1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,51.6h-15.1v6.9h13.2c1.7,0,3.1,1.4,3.1,3.1v65.5h7V59.7c0-4.5-3.7-8.2-8.2-8.2Z",
    style: {
      fill: "#b40055"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,77.5h0c-2,0-3.7-1.6-3.7-3.7V29.7c0-10.7-8.3-19.9-19.1-20.3-11.2-.4-20.5,8.6-20.5,19.8v44.6c0,2-1.6,3.7-3.7,3.7h0c-2,0-3.7-1.6-3.7-3.7V29.8c0-14.8,11.6-27.3,26.3-27.7,15.3-.4,27.9,11.9,27.9,27.1v44.6c0,2-1.6,3.7-3.7,3.7Z",
    style: {
      fill: "#b41257"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.2,113.8h-5.3v-20.6l-5.6,2.8v-5.3l6.2-3.3h4.7v26.4Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,114.2c-.9,0-1.7-.3-2.3-1-.6-.6-.9-1.4-.9-2.4s.3-1.7.9-2.3,1.4-.9,2.3-.9,1.7.3,2.3.9c.6.6,1,1.4,1,2.3s-.3,1.7-1,2.4-1.4,1-2.3,1Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.9,114.3c-2.3,0-4.4-.7-6.1-2-1.7-1.3-3-2.9-3.9-5-.9-2-1.3-4.3-1.3-6.8s.4-4.7,1.3-6.7c.9-2.1,2.2-3.8,4-5.1,1.8-1.3,3.8-1.9,6.1-1.9,3.5,0,6.2,1.3,8.2,4,2.1,2.7,3.1,5.9,3.1,9.7s-1,7-3.1,9.7c-2,2.7-4.8,4-8.2,4ZM214.6,106.8c1.1,1.7,2.5,2.5,4.3,2.5s3.2-.8,4.3-2.5c1.1-1.7,1.6-3.7,1.6-6.1s-.5-4.5-1.6-6.1c-1.1-1.7-2.5-2.5-4.3-2.5s-3.3.8-4.3,2.5c-1.1,1.6-1.6,3.7-1.6,6.1s.5,4.5,1.6,6.1Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,114.3c-2.3,0-4.4-.7-6.1-2-1.7-1.3-3-2.9-3.9-5-.9-2-1.3-4.3-1.3-6.8s.4-4.7,1.3-6.7c.9-2.1,2.2-3.8,4-5.1,1.8-1.3,3.8-1.9,6.1-1.9,3.5,0,6.2,1.3,8.2,4,2.1,2.7,3.1,5.9,3.1,9.7s-1,7-3.1,9.7c-2,2.7-4.8,4-8.2,4ZM241.1,106.8c1.1,1.7,2.5,2.5,4.3,2.5s3.2-.8,4.3-2.5c1.1-1.7,1.6-3.7,1.6-6.1s-.5-4.5-1.6-6.1c-1.1-1.7-2.5-2.5-4.3-2.5s-3.3.8-4.3,2.5c-1.1,1.6-1.6,3.7-1.6,6.1s.5,4.5,1.6,6.1Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,114.3c-2.3,0-4.4-.7-6.1-2-1.7-1.3-3-2.9-3.9-5-.9-2-1.3-4.3-1.3-6.8s.4-4.7,1.3-6.7c.9-2.1,2.2-3.8,4-5.1,1.8-1.3,3.8-1.9,6.1-1.9,3.5,0,6.2,1.3,8.2,4,2.1,2.7,3.1,5.9,3.1,9.7s-1,7-3.1,9.7c-2,2.7-4.8,4-8.2,4ZM267.7,106.8c1.1,1.7,2.5,2.5,4.3,2.5s3.2-.8,4.3-2.5c1.1-1.7,1.6-3.7,1.6-6.1s-.5-4.5-1.6-6.1c-1.1-1.7-2.5-2.5-4.3-2.5s-3.3.8-4.3,2.5c-1.1,1.6-1.6,3.7-1.6,6.1s.5,4.5,1.6,6.1Z",
    style: {
      fill: "#fac328"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.5,91.9v-4.6h21.1v4.6h-8v20.5h-5.2v-20.5h-7.9Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.9,94.5v17.9h-5.1v-2.2c-1.6,1.7-3.6,2.6-6,2.6s-3.7-.7-4.8-2c-1.1-1.3-1.7-3.1-1.7-5.4v-11h5.1v9.9c0,1.3.3,2.2,1,2.9.6.6,1.5.9,2.5.9s1.5-.2,2.3-.7,1.3-1,1.8-1.7v-11.4h5.1ZM318.2,92c-.7,0-1.3-.3-1.9-.8-.5-.5-.8-1.1-.8-1.9s.3-1.3.8-1.8c.5-.5,1.1-.8,1.9-.8s1.4.3,1.9.8c.5.5.8,1.1.8,1.9s-.3,1.4-.8,1.9c-.5.5-1.1.8-1.9.8ZM327.9,91.2c-.5.5-1.1.8-1.9.8s-1.4-.3-1.9-.8c-.5-.5-.8-1.2-.8-1.9s.3-1.4.8-1.9c.5-.5,1.2-.8,1.9-.8s1.4.3,1.9.8c.5.5.8,1.1.8,1.9s-.3,1.4-.8,1.9Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,106.8v-8.1h-3.5v-4.2h3.5v-4.9h5.1v4.9h5.1v4.2h-5.1v7.1c0,.9.2,1.5.6,1.9.4.4,1,.6,1.9.6s1.8-.2,2.6-.6v4.2c-1.1.6-2.5,1-4.3,1-3.9,0-5.8-2-5.8-6Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.2,112.9c-2.7,0-4.9-.9-6.9-2.6-1.9-1.8-2.9-4.1-2.9-6.9s1-5.1,2.9-6.8c1.9-1.7,4.2-2.6,6.9-2.6s3.7.4,5.3,1.2v4.3c-1.6-.7-3.1-1.1-4.6-1.1s-2.9.5-4,1.4c-1.1.9-1.6,2.1-1.6,3.6s.5,2.7,1.6,3.6c1.1.9,2.4,1.4,3.9,1.4s3.5-.4,4.8-1.2v4.3c-1.7.9-3.6,1.3-5.7,1.3Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.2,101v11.4h-5.1v-25.1h5.1v9.4c1.6-1.8,3.6-2.7,6-2.7s3.7.7,4.8,2,1.7,3.1,1.7,5.4v11h-5.1v-9.9c0-1.3-.3-2.2-1-2.9-.6-.6-1.5-.9-2.5-.9s-1.5.2-2.3.7-1.3,1-1.8,1.7Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,112.9c-2.8,0-5.2-.9-7.1-2.6-1.9-1.7-2.9-4-2.9-6.9s.9-4.9,2.6-6.7c1.7-1.8,4-2.7,6.7-2.7s4.7.9,6.2,2.8c1.6,1.8,2.3,4.1,2.3,6.7v1.3h-12.8c.3,1.2.9,2.1,2,2.8,1.1.6,2.4,1,4,1s3.9-.5,5.7-1.6v4.1c-1.6,1.2-3.9,1.8-6.8,1.8ZM396.2,101.6h7.9c0-1-.4-1.9-1.1-2.6-.7-.7-1.6-1-2.7-1s-2.1.3-2.8,1c-.7.7-1.2,1.5-1.3,2.6Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,101v11.4h-5.1v-17.9h5.1v2.2c1.6-1.7,3.6-2.6,6-2.6s3.7.7,4.8,2,1.7,3.1,1.7,5.4v11h-5.1v-9.9c0-1.3-.3-2.2-1-2.9-.6-.6-1.5-.9-2.5-.9s-1.5.2-2.3.7-1.3,1-1.8,1.7Z",
    style: {
      fill: "#fac328"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.7,148.9c-3.8,0-7-1.2-9.5-3.7-2.6-2.5-3.8-5.6-3.8-9.4s1.3-7,3.8-9.4c2.5-2.4,5.8-3.7,9.7-3.7s5.4.6,7.5,1.9v5.1c-2.3-1.4-4.7-2.2-7.2-2.2s-4.6.8-6.2,2.3c-1.6,1.5-2.4,3.5-2.4,6s.8,4.5,2.3,6c1.6,1.5,3.5,2.2,5.8,2.2s3.9-.5,5.1-1.6v-8.6h5.2v11.1c-1.1,1.1-2.5,2.1-4.3,2.8-1.9.8-3.8,1.1-5.9,1.1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,141.9v-11.4h5.1v17.9h-5.1v-2.2c-1.6,1.7-3.6,2.6-6,2.6s-3.7-.7-4.8-2c-1.1-1.3-1.7-3.1-1.7-5.4v-11h5.1v9.9c0,1.3.3,2.2,1,2.9.6.6,1.5.9,2.5.9s1.5-.2,2.3-.7,1.3-1,1.8-1.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,147.7h-5.1v-17.9h5.1v2.2c1.3-1.8,3.2-2.7,5.5-2.7s2.4.3,3.5.9c1,.6,1.7,1.3,2.1,2.2.6-.9,1.5-1.6,2.6-2.2,1.1-.6,2.3-.8,3.6-.8,2,0,3.5.6,4.7,1.9s1.7,3,1.7,5.3v11.2h-5.1v-10c0-2.5-1-3.7-3-3.7s-1.5.2-2.2.7-1.2,1-1.5,1.8v11.3h-5.1v-10c0-2.5-1-3.7-3-3.7s-1.4.2-2.2.7c-.7.5-1.3,1-1.6,1.7v11.4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,147.9h-5.1v-17.9h5.1v2.2c1.3-1.8,3.2-2.7,5.5-2.7s2.4.3,3.5.9c1,.6,1.7,1.3,2.1,2.2.6-.9,1.5-1.6,2.6-2.2,1.1-.6,2.3-.8,3.6-.8,2,0,3.5.6,4.7,1.9s1.7,3,1.7,5.3v11.2h-5.1v-10c0-2.5-1-3.7-3-3.7s-1.5.2-2.2.7-1.2,1-1.5,1.8v11.3h-5.1v-10c0-2.5-1-3.7-3-3.7s-1.4.2-2.2.7c-.7.5-1.3,1-1.6,1.7v11.4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,125.8c0-.9.3-1.6.9-2.2.6-.6,1.3-.9,2.1-.9s1.5.3,2.1.9c.6.6.9,1.3.9,2.2s-.3,1.5-.9,2.1-1.3.9-2.1.9-1.5-.3-2.1-.9-.9-1.3-.9-2.1ZM300.5,148.4h-5.1v-17.9h5.1v17.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,148.9c-2.6,0-4.5-.9-5.9-2.7v2.2h-5.1v-25.1h5.1v9.4c1.4-1.8,3.4-2.7,5.9-2.7s4.4.9,6,2.7c1.6,1.8,2.4,4,2.4,6.7s-.8,4.9-2.4,6.7c-1.6,1.8-3.6,2.7-6,2.7ZM315.3,144.5c1.4,0,2.6-.5,3.5-1.4.9-1,1.4-2.2,1.4-3.6s-.5-2.6-1.4-3.6c-.9-1-2-1.4-3.5-1.4s-1.8.2-2.6.7-1.4,1.1-1.8,1.9v4.7c.4.8,1,1.4,1.8,1.9s1.7.8,2.6.8Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,144.5c.4,0,.8,0,1-.2v3.7c-.6.5-1.6.8-2.7.8-2,0-3.4-.8-4.1-2.3-1.6,1.6-3.6,2.4-6.2,2.4s-3.6-.5-4.8-1.6c-1.2-1.1-1.8-2.5-1.8-4.3s.7-3.4,2.1-4.4c1.4-1,3-1.5,5-1.5s3.8.4,5.2,1.1v-.5c0-2.2-1.6-3.4-4.7-3.4s-3.7.5-5.4,1.5v-4.2c1.8-1,4-1.4,6.6-1.4s4.6.6,6.2,1.9c1.6,1.2,2.4,3,2.4,5.2v6.1c0,.9.4,1.4,1.3,1.4ZM332.5,128c-.7,0-1.3-.3-1.9-.8-.5-.5-.8-1.1-.8-1.9s.3-1.3.8-1.8c.5-.5,1.1-.8,1.9-.8s1.4.3,1.9.8.8,1.1.8,1.9-.3,1.4-.8,1.9-1.1.8-1.9.8ZM339.6,141.3c-1.1-.7-2.3-1-3.7-1s-1.9.2-2.6.6-1,1-1,1.7.3,1.3.9,1.7c.6.4,1.3.6,2.3.6,1.8,0,3.1-.6,4.1-1.8v-1.8ZM342.2,127.2c-.5.5-1.1.8-1.9.8s-1.4-.3-1.9-.8c-.5-.5-.8-1.2-.8-1.9s.3-1.4.8-1.9c.5-.5,1.2-.8,1.9-.8s1.4.3,1.9.8c.5.5.8,1.1.8,1.9s-.3,1.4-.8,1.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5,148.4h-5.1v-17.9h5.1v3c.5-1,1.4-1.8,2.5-2.4,1.2-.7,2.4-1,3.7-1s.5,0,.6,0v4.9c-.5-.1-1-.2-1.6-.2-1.2,0-2.2.3-3.2.9-1,.6-1.6,1.3-2,2.2v10.4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.2,148.9c-2.7,0-4.9-.9-6.9-2.6-1.9-1.8-2.9-4.1-2.9-6.9s1-5.1,2.9-6.8c1.9-1.7,4.2-2.6,6.9-2.6s3.7.4,5.3,1.2v4.3c-1.6-.7-3.1-1.1-4.6-1.1s-2.9.5-4,1.4c-1.1.9-1.6,2.1-1.6,3.6s.5,2.7,1.6,3.6c1.1.9,2.4,1.4,3.9,1.4s3.5-.4,4.8-1.2v4.3c-1.7.9-3.6,1.3-5.7,1.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2,137v11.4h-5.1v-25.1h5.1v9.4c1.6-1.8,3.6-2.7,6-2.7s3.7.7,4.8,2,1.7,3.1,1.7,5.4v11h-5.1v-9.9c0-1.3-.3-2.2-1-2.9-.6-.6-1.5-.9-2.5-.9s-1.5.2-2.3.7-1.3,1-1.8,1.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,148.9c-2.8,0-5.2-.9-7.1-2.6-1.9-1.7-2.9-4-2.9-6.9s.9-4.9,2.6-6.7c1.7-1.8,4-2.7,6.7-2.7s4.7.9,6.2,2.8c1.6,1.8,2.3,4.1,2.3,6.7v1.3h-12.8c.3,1.2.9,2.1,2,2.8,1.1.6,2.4,1,4,1s3.9-.5,5.7-1.6v4.1c-1.6,1.2-3.9,1.8-6.8,1.8ZM410.1,137.6h7.9c0-1-.4-1.9-1.1-2.6-.7-.7-1.6-1-2.7-1s-2.1.3-2.8,1c-.7.7-1.2,1.5-1.3,2.6Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9,137v11.4h-5.1v-17.9h5.1v2.2c1.6-1.7,3.6-2.6,6-2.6s3.7.7,4.8,2,1.7,3.1,1.7,5.4v11h-5.1v-9.9c0-1.3-.3-2.2-1-2.9-.6-.6-1.5-.9-2.5-.9s-1.5.2-2.3.7-1.3,1-1.8,1.7Z",
    style: {
      fill: "#b40055"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.6,74.3h-4.8l9.6-22.5h4.4l9.6,22.5h-4.9l-2.2-5.2h-9.4l-2.2,5.2ZM189.5,57.6l-3.3,7.8h6.5l-3.3-7.8Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,74.8c-2.3,0-4-.8-5.2-2.4v1.9h-4.5v-22.3h4.5v8.4c1.3-1.6,3-2.4,5.2-2.4s4,.8,5.4,2.4c1.4,1.6,2.1,3.6,2.1,5.9s-.7,4.4-2.1,6c-1.4,1.6-3.2,2.4-5.4,2.4ZM212.5,70.8c1.3,0,2.3-.4,3.1-1.3.8-.9,1.2-1.9,1.2-3.2s-.4-2.3-1.2-3.2c-.8-.9-1.8-1.3-3.1-1.3s-1.6.2-2.3.7-1.2,1-1.6,1.7v4.1c.4.7.9,1.3,1.6,1.7s1.5.7,2.3.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,74.3h-4.5v-17.4l-4.7,2.4v-4.5l5.2-2.8h4v22.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,74.3h-4.5v-17.4l-4.7,2.4v-4.5l5.2-2.8h4v22.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,74.3h-4.5v-17.4l-4.7,2.4v-4.5l5.2-2.8h4v22.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,74.8c-3.4,0-6.2-.8-8.5-2.4v-4.8c.9.8,2.2,1.5,3.7,2.1,1.6.6,3.1.9,4.6.9s2.3-.2,3.1-.7c.8-.5,1.2-1.1,1.2-1.9s-.4-1.5-1.1-1.9c-.3-.2-.7-.4-1.3-.6l-.8-.3-1.8-.5-1.7-.5c-.2,0-.7-.2-1.5-.5-.7-.3-1.1-.5-1.4-.7-1.1-.8-1.8-1.4-2.1-1.9-.5-1-.8-2.1-.8-3.1,0-2,.8-3.5,2.3-4.7,1.5-1.1,3.6-1.7,6.2-1.7s5.1.6,7.3,1.9v4.5c-2.3-1.4-4.7-2.1-7.2-2.1s-3.8.7-3.8,2.2.4,1.1,1.2,1.5c.5.3,1.1.5,1.8.7,1,.3,1.8.5,2.4.7,1.9.6,3.5,1.4,4.9,2.3,1.5,1,2.2,2.6,2.2,4.7s-.8,3.8-2.5,5.1c-1.7,1.2-3.8,1.9-6.4,1.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,69.4v-7.2h-3.1v-3.8h3.1v-4.4h4.5v4.4h4.5v3.8h-4.5v6.3c0,.8.2,1.4.5,1.7.3.4.9.5,1.7.5s1.6-.2,2.3-.6v3.7c-.9.6-2.2.9-3.8.9-3.5,0-5.2-1.8-5.2-5.4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,54.2c0-.8.3-1.4.8-1.9.5-.5,1.2-.8,1.9-.8s1.4.3,1.9.8c.5.5.8,1.2.8,1.9s-.3,1.4-.8,1.9-1.2.8-1.9.8-1.4-.3-1.9-.8-.8-1.2-.8-1.9ZM316.8,74.3h-4.5v-15.9h4.5v15.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.9,74.3h-4.5v-15.9h4.5v1.9c1.2-1.6,2.8-2.4,4.9-2.4s2.2.3,3.1.8c.9.5,1.5,1.2,1.9,1.9.5-.8,1.3-1.5,2.3-2,1-.5,2.1-.8,3.2-.8,1.7,0,3.1.6,4.1,1.7s1.5,2.7,1.5,4.7v10h-4.5v-8.9c0-2.2-.9-3.3-2.6-3.3s-1.3.2-1.9.6-1.1.9-1.4,1.6v10.1h-4.5v-8.9c0-2.2-.9-3.3-2.6-3.3s-1.3.2-1.9.6c-.6.4-1.1.9-1.4,1.5v10.1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5,74.3h-4.5v-15.9h4.5v1.9c1.2-1.6,2.8-2.4,4.9-2.4s2.2.3,3.1.8c.9.5,1.5,1.2,1.9,1.9.5-.8,1.3-1.5,2.3-2,1-.5,2.1-.8,3.2-.8,1.7,0,3.1.6,4.1,1.7s1.5,2.7,1.5,4.7v10h-4.5v-8.9c0-2.2-.9-3.3-2.6-3.3s-1.3.2-1.9.6-1.1.9-1.4,1.6v10.1h-4.5v-8.9c0-2.2-.9-3.3-2.6-3.3s-1.3.2-1.9.6c-.6.4-1.1.9-1.4,1.5v10.1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,74.8c-2.5,0-4.6-.8-6.3-2.3-1.7-1.5-2.6-3.6-2.6-6.1s.8-4.3,2.3-5.9c1.5-1.6,3.5-2.4,6-2.4s4.1.8,5.5,2.5c1.4,1.6,2.1,3.6,2.1,6v1.2h-11.4c.2,1.1.8,1.9,1.8,2.5.9.6,2.1.9,3.6.9s3.5-.5,5.1-1.4v3.6c-1.4,1.1-3.4,1.6-6.1,1.6ZM384,64.7h7c0-.9-.4-1.7-1-2.3-.6-.6-1.4-.9-2.4-.9s-1.8.3-2.5.9c-.7.6-1,1.4-1.1,2.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,64.2v10.2h-4.5v-15.9h4.5v1.9c1.4-1.6,3.2-2.3,5.3-2.3s3.3.6,4.3,1.7,1.5,2.8,1.5,4.8v9.8h-4.5v-8.8c0-1.1-.3-2-.8-2.6-.6-.6-1.3-.8-2.2-.8s-1.4.2-2,.6-1.2.9-1.6,1.5Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.6,64.2c-.8,0-1.4-.3-2-.8s-.8-1.2-.8-2,.3-1.4.8-1.9,1.2-.8,2-.8,1.4.3,2,.8c.5.5.8,1.2.8,1.9s-.3,1.5-.8,2c-.5.5-1.2.8-2,.8ZM420.6,74.7c-.8,0-1.4-.3-2-.8-.5-.5-.8-1.2-.8-2s.3-1.4.8-1.9,1.2-.8,2-.8,1.4.3,2,.8c.5.5.8,1.2.8,1.9s-.3,1.5-.8,2-1.2.8-2,.8Z",
    style: {
      fill: "#b40055"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineLgRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-lg-rgb.d08a1f1b26f71618ef7506385cdc2980.svg";